import { Amplify } from "aws-amplify";

export function configureAmplify() {
  const region = process.env.REACT_APP_AWS_REGION;
  const userPoolId = process.env.REACT_APP_COGNITO_USER_POOL_ID;
  const userPoolWebClientId = process.env.REACT_APP_COGNITO_USER_POOL_CLIENT_ID;
  const identityPoolId = process.env.REACT_APP_COGNITO_IDENTITY_POOL_ID;
  const enableIdentityPool =
    (process.env.REACT_APP_ENABLE_IDENTITY_POOL || "false").toLowerCase() === "true";
  const hostedDomain = process.env.REACT_APP_COGNITO_HOSTED_UI_DOMAIN;
  const redirectSignIn = process.env.REACT_APP_COGNITO_REDIRECT_SIGNIN;
  const redirectSignOut = process.env.REACT_APP_COGNITO_REDIRECT_SIGNOUT;

  const cognito = {
    userPoolId: userPoolId ?? "",
    userPoolClientId: userPoolWebClientId ?? "",
    loginWith: { username: false, email: true, phone: false },
    signUpVerificationMethod: "code",
    userAttributes: { email: { required: true } },
    ...(identityPoolId && enableIdentityPool && { identityPoolId }),
  };

  const authConfig = {
    Auth: {
      Cognito: cognito,
      ...(region && { region }),
      ...(hostedDomain &&
        redirectSignIn &&
        redirectSignOut && {
          OAuth: {
            domain: hostedDomain.replace(/^https?:\/\//, ""),
            redirectSignIn,
            redirectSignOut,
            responseType: "code",
            scope: ["email", "openid"],
          },
        }),
    },
  };

  Amplify.configure(authConfig as Parameters<typeof Amplify.configure>[0]);
}

export function isHostedUIConfigured(): boolean {
  return Boolean(
    process.env.REACT_APP_COGNITO_HOSTED_UI_DOMAIN &&
      process.env.REACT_APP_COGNITO_REDIRECT_SIGNIN &&
      process.env.REACT_APP_COGNITO_REDIRECT_SIGNOUT
  );
}
